import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmpty } from "lodash";
import React, { memo, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { SEARCH_FROM } from "src/utils/constant";
import { unsubscribeDataByScrip } from "../../../src/utils/websocketwrapper";
import styles from "../../components/search/search.module.scss";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import useDataHook from "../../pages/dashboard/option-chain/useDataHook";
import { currencyDecimal, getDefaultDateFormat, intComma, } from "../../utils/methods";
import TextFromExchange from "./exchange-text";
import { openGuestLoginModal } from "src/redux/reducers/modals";
const { REACT_APP_URL_ASSET_BASE_PATH } = process.env;
const { REACT_APP_ENV } = process.env;
const componentName = "SingleSearchRow";
const SingleSearchRow = React.forwardRef(({ toggleModal, searchFrom, index, singleScript, stockType, exchangeTypeColor, exchangeColor, priceData, valueChangeAndPercentage, stockInfoPage, onChartIconClick, onAddToWatchlist, openAddToBasket, buySellCallback, }, ref) => {
    var _a, _b;
    const { ref: observerRef, inView } = useInView({
        threshold: 0,
    });
    const openFeedWsHeartBeat = useAppSelector((state) => state.openFeedWs.heartBeat);
    const dispatch = useAppDispatch();
    const dataForSocket = {
        strike: singleScript.StrikeRate,
        symbol: singleScript.ShortName,
        expiry: singleScript.ExpiryDate,
        putName: "",
        putExch: "",
        putExchType: "",
        putScripCode: 0,
        putLTP: 0,
        prevPutClose: 0,
        callName: "",
        callExch: "",
        callExchType: "",
        callScripCode: 0,
        callLTP: 0,
        prevCallClose: 0,
        inView: inView,
        observerRef,
        isChecked: false,
        onVisibilityChange: (strike, callScripCode, putScripCode, visible) => undefined,
        // position: index,
        lotSize: 0,
        selectedOptionType: "",
        componentName: componentName,
    };
    const { sendWsMessage } = useDataHook(dataForSocket);
    useEffect(() => {
        const data = [
            {
                Exch: singleScript.Exch,
                ExchType: singleScript.ExchType,
                ScripCode: singleScript.ScripCode,
            },
        ];
        if (inView) {
            sendWsMessage(openFeedWsHeartBeat, "Subscribe", data);
        }
        else {
            unsubscribeDataByScrip(componentName, {
                Exch: singleScript.Exch,
                ExchType: singleScript.ExchType,
                ScripCode: singleScript.ScripCode,
            });
        }
        return () => {
            unsubscribeDataByScrip(componentName, {
                Exch: singleScript.Exch,
                ExchType: singleScript.ExchType,
                ScripCode: singleScript.ScripCode,
            });
        };
    }, [
        singleScript.Exch,
        singleScript.ExchType,
        singleScript.ScripCode,
        inView,
        openFeedWsHeartBeat,
        index,
    ]);
    // useEffect(() => {
    // }, []);
    const shimmer = () => {
        return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ className: "shimmer" }, { children: "\u00A0" })) }));
    };
    const exchangeTextCallback = (exchangeText, exchangeColor) => {
        return _jsx("span", Object.assign({ className: `${exchangeColor}` }, { children: exchangeText }));
    };
    return (_jsx(_Fragment, { children: _jsxs("tr", Object.assign({ className: "", ref: observerRef }, { children: [_jsx("td", Object.assign({ className: `${styles.stockNames} pointer`, onClick: () => {
                        stockInfoPage(singleScript, priceData[0]);
                    } }, { children: singleScript.ScripCode == 999920019 ? (_jsx("span", Object.assign({ className: "text-uppercase", title: singleScript.Name }, { children: singleScript.Name }))) : (_jsx("span", Object.assign({ title: stockType == "CASH"
                            ? singleScript.Name
                            : singleScript.ShortName }, { children: stockType == "CASH"
                            ? singleScript.Name
                            : singleScript.ShortName }))) })), _jsx("td", { children: _jsx("span", Object.assign({ className: styles.stockDate }, { children: isEmpty(singleScript.ExpiryDate) ||
                            singleScript.ScripCode == 999920019
                            ? ""
                            : getDefaultDateFormat(singleScript.ExpiryDate) })) }), _jsx("td", { children: singleScript.ScripCode !== 999920019 && (_jsx("span", Object.assign({ className: `${exchangeTypeColor}` }, { children: stockType }))) }), _jsx("td", { children: singleScript.StrikeRate && (_jsx("span", Object.assign({ className: styles.strikeRate }, { children: singleScript.StrikeRate &&
                            (Number.isInteger(singleScript.StrikeRate)
                                ? intComma(singleScript.StrikeRate, 0)
                                : intComma(singleScript.StrikeRate, 4)) }))) }), _jsx("td", { children: singleScript.ScripCode !== 999920019 && (_jsx(TextFromExchange, { exchange: singleScript.Exch, exchangeType: singleScript.ExchType, renderExchangeText: exchangeTextCallback })) }), _jsx("td", { children: priceData == undefined || priceData.length == 0 ? (shimmer()) : (_jsx("span", Object.assign({ className: `${styles.lastRate}` }, { children: singleScript.ExchType == "U"
                            ? currencyDecimal((_a = priceData[0]) === null || _a === void 0 ? void 0 : _a.LastRate)
                            : intComma((_b = priceData[0]) === null || _b === void 0 ? void 0 : _b.LastRate) }))) }), _jsx("td", { children: priceData == undefined || priceData.length == 0 ? (shimmer()) : (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: `${styles.successTextBelowImage} ${valueChangeAndPercentage.isNegative
                                    ? "negativeText"
                                    : "positiveText"} ${valueChangeAndPercentage.differenceValue == "0"
                                    ? styles.zeroPClose
                                    : ""} ${styles.valueFixWidth} textLeft`, style: { textAlign: "right", marginRight: 0 } }, { children: [valueChangeAndPercentage.differenceValue, " (", valueChangeAndPercentage.differencePercentage, ")"] })), searchFrom === SEARCH_FROM.VTT ? (_jsx("ul", Object.assign({ className: `${styles.actionItemList}` }, { children: _jsx("li", { children: _jsxs("div", Object.assign({ className: "buySellButtonPanel" }, { children: [_jsx("button", Object.assign({ onClick: () => {
                                                    toggleModal();
                                                    buySellCallback(true, singleScript, priceData[0]);
                                                }, disabled: !(singleScript.IndexId === -1) }, { children: "B" })), _jsx("button", Object.assign({ onClick: () => {
                                                    toggleModal();
                                                    buySellCallback(false, singleScript, priceData[0]);
                                                }, disabled: !(singleScript.IndexId === -1) }, { children: "S" }))] })) }) }))) : searchFrom === SEARCH_FROM.BASKET ? (_jsx("div", Object.assign({ className: `${styles.addBtnShowWrapper}` }, { children: _jsxs("button", Object.assign({ type: "button", className: "btnType1 d-flex", onClick: () => {
                                        openAddToBasket(true, singleScript, priceData[0]);
                                    }, disabled: singleScript.IndexId === -1 ? false : true }, { children: [singleScript.IndexId === -1 ? (_jsx("span", { className: "basketIconWhite me-1" })) : (_jsx("span", { className: "basketIconGrey me-1" })), "Add"] })) }))) : ("")] })) }), _jsx("td", Object.assign({ className: `${searchFrom !== SEARCH_FROM.GLOBAL ? "hide" : ""}` }, { children: _jsxs("div", Object.assign({ className: "d-flex align-items-center justify-content-end flex-nowrap" }, { children: [_jsx("span", { className: "chartIcon me-2 pointer", 
                                // onClick={() => {
                                //   onChartIconClick(singleScript);
                                // }}
                                onClick: () => dispatch(openGuestLoginModal()), title: "Open chart" }), _jsx("span", { className: "watchlistIcon ms-1 pointer", 
                                // onClick={() => {
                                //   onAddToWatchlist(singleScript);
                                // }}
                                onClick: () => dispatch(openGuestLoginModal()), title: "Add to watchlist" }), _jsx("span", { className: `${singleScript.IndexId === -1
                                    ? "basketIconBlue"
                                    : "basketIconBlueDisabled"} ms-2 pointer`, onClick: () => {
                                    singleScript.IndexId === -1 &&
                                        openAddToBasket(true, singleScript, priceData[0]);
                                }, title: "Add to basket" }), _jsxs("div", Object.assign({ className: styles.buysellPanel }, { children: [_jsx("button", Object.assign({ onClick: () => {
                                            singleScript.IndexId === -1 &&
                                                buySellCallback(true, singleScript, priceData[0]);
                                        }, disabled: singleScript.IndexId === -1 ? false : true }, { children: "B" })), _jsx("button", Object.assign({ onClick: () => {
                                            singleScript.IndexId === -1 &&
                                                buySellCallback(false, singleScript, priceData[0]);
                                        }, disabled: singleScript.IndexId === -1 ? false : true }, { children: "S" }))] }))] })) }))] }), "id-" + index) }));
});
SingleSearchRow.displayName = "SingleSearchRow";
export default memo(SingleSearchRow);
